import React from "react";
import Slider from "react-slick";
import get from "lodash/get";
import { Link, ResponsiveHeroImage, ReviewRating } from "@quintype/components";
import canUseDom from "../../../utils/can-use-dom";
import { SectionName } from "../basic/section-name.js";
import { ImageFallback } from "../basic/image-fallback.js";
import { wrapCollectionLayout } from "@quintype/components";
import { collectionSection } from "./collection-layout-helper.js";
import { altTagOfHeroImages} from "../../utils";


function FullscreenLinearGallerySliderBase({collection, stories, config, associatedMetadata}) {
  const settings = {
    centerMode: true,
    centerPadding: '130px',
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 5000,
    rtl: get(config, ['theme-attributes', 'language_direction']) === 'right',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerPadding: '20px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerPadding: '80px',
          slidesToShow: 1
        }
      }
    ]
  };
  const inlineStyle = {
    color: '#fff',
    marginBottom: '0'
  }
  const  {'show_collection_title': collectionName = true} = associatedMetadata;
  if(!stories) {
    return null
  }

  return (
    <div className="linear-gallery-slider component-wrapper-fluid">
      <div className="linear-gallery-slider__heading">
        {collectionName ? <SectionName hideLink={true} inlineStyle={inlineStyle} name={collection.name} type="large" section={collectionSection(config, collection)} /> : null}
      </div>
      {canUseDom &&
      <Slider {...settings} className="linear-gallery-slider__slides">
        {stories.map((story, index) =>
          <div key={`${story.id}-${index}`} className="linear-gallery-slider__slider-content">
            <SliderItem story={story} />
          </div>
        )}
      </Slider> }
    </div>
  )
}

function SliderItem({story}) {
  const isReviewStory = story["story-template"] === 'review';
  return (
    <Link href={"/" + story.slug }>
    { story["hero-image-s3-key"] ?
      <figure className={`linear-gallery-slider__image--${story['story-template']}`}>
        <ResponsiveHeroImage story={story}
          aspectRatio={[4,3]}
          alt={altTagOfHeroImages(story)}
          defaultWidth={320} widths={[250,480,640]}
          imgParams={{auto:['format', 'compress'], fit:'max'}}/>
      </figure> :
      <ImageFallback />
    }
      <p className="linear-gallery-slider__item-title" dangerouslySetInnerHTML={{__html:story.headline}}></p>
      {isReviewStory && <ReviewRating value={get(story, ['metadata','review-rating', 'value'], '0')} />}
    </Link>
  )
}

export const FullscreenLinearGallerySlider = wrapCollectionLayout(FullscreenLinearGallerySliderBase);
